export default [{
  title: '基础信息',
  items: [
    //   {
    //   icon: 'account_box',
    //   title: '用户管理',
    //   path: '/user/list',
    //   permission: 'User'
    // },
    // {
    //   icon: 'settings_applications',
    //   title: '权限管理',
    //   path: '/permission/list',
    //   permission: 'Permission'
    // },
    // {
    //   icon: 'settings_applications',
    //   title: '角色管理',
    //   path: '/role/list',
    //   permission: 'Role'
    // },
    {
      icon: 'get_app',
      title: 'APP版本管理',
      path: '/appversion/list',
      permission: 'AppVersion'
    },
    {
      icon: 'perm_media',
      title: '资源库',
      path: '/meidia/list',
      permission: 'Meidia'
    }
  ]
}, {
  title: '内容管理',
  items: [{
    icon: 'list',
    title: '关于通久',
    path: '/about/list',
    permission: 'About'
  },
  {
    icon: 'merge_type',
    title: '投屏教程',
    path: '/tutorial/list',
    permission: 'Tutorial'
  },
  {
    icon: 'toll',
    title: '注册协议',
    path: '/regprotocol/list',
    permission: 'RegProtocol'
  },
  ]
}, {
  title: '配置管理',
  items: [{
    icon: 'search',
    title: '搜索引擎配置',
    path: '/searchItem/list',
    permission: 'SearchItem'
  },
  {
    icon: 'merge_type',
    title: '电视频道分类',
    path: '/tvcategory/list',
    permission: 'TVCategory'
  },
  {
    icon: 'tv',
    title: '电视频道',
    path: '/tvchannel/list',
    permission: 'TVChannel'
  },
  {
    icon: 'ondemand_video',
    title: '外链视频站',
    path: '/thirdpartysite/list',
    permission: 'ThirdPartySite'
  },
  {
    icon: 'photo_size_select_actual',
    title: '广告管理',
    path: '/advertise/list',
    permission: 'Advertise'
  },
  {
    icon: 'insert_comment',
    title: '留言管理',
    path: '/usercomment/list',
    permission: 'UserComment'
  },
  ]
}]